export default "__VITE_ASSET__DV7c6QSo__"